export const ROLES = ['student', 'professional', 'company', 'startup', 'admin'];

export const ROLE_LABEL = { student: 'Student / Job seeker', professional: 'Freelancer', company: 'Company', startup: 'Startup', admin: 'Admin' };

export const CATEGORIES = ['Software testing', 'Software development', 'Data and analytics', 'Design (UI/UX)', 'Digital marketing', 'Product management', 'DevOps and cloud', 'Other'];
export const EXPERIENCE = ['Fresher', '0–2 years', '1–3 years', '3–5 years', '5+ years'];
export const LOCATIONS = ['Remote', 'Hyderabad', 'Bengaluru', 'Chennai', 'Pune', 'Mumbai', 'Delhi NCR', 'Kolkata', 'Ahmedabad', 'Kochi', 'Visakhapatnam', 'Vijayawada', 'Warangal', 'Coimbatore', 'Jaipur', 'Indore', 'Other'];
export const BUDGET_TYPES = ['Annual salary (CTC)', 'Monthly stipend', 'Fixed project fee', 'Hourly rate'];
export const WORK_MODES = ['On-site', 'Hybrid', 'Remote'];
export const ENGAGEMENT_TYPES = [
  ['Full-time', 'Permanent role'], ['Internship', 'Students, 1–6 months'], ['Freelance', 'Fixed project'], ['Part-time', 'Few hours a week'], ['Co-founder', 'Equity based'],
];

/** Suggestions for the skill tag input. People can still type anything. */
export const SKILL_SUGGESTIONS = ['Manual Testing', 'API Testing', 'Automation Testing', 'Selenium', 'Java', 'Jira', 'Bug Reporting', 'Postman', 'React', 'JavaScript', 'TypeScript', 'Node.js', 'HTML', 'CSS', 'Python', 'SQL', 'Pandas', 'Power BI', 'Excel', 'Figma', 'UX Research', 'Wireframing', 'Flutter', 'Dart', 'AWS', 'SEO', 'Ads', 'Content Writing', 'Data Analysis', 'Machine Learning'];

export const PIPELINE_STAGES = ['Shortlisted', 'Interview', 'Offer', 'Hired'];

export const WEEKDAYS = [[0, 'Mon'], [1, 'Tue'], [2, 'Wed'], [3, 'Thu'], [4, 'Fri'], [5, 'Sat'], [6, 'Sun']];



/** For the GST place of supply on invoices (CGST+SGST inside the supplier's state, IGST outside). */
export const INDIAN_STATES = [
  'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh', 'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand',
  'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab', 'Rajasthan',
  'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal', 'Andaman and Nicobar Islands', 'Chandigarh',
  'Dadra and Nagar Haveli and Daman and Diu', 'Delhi', 'Jammu and Kashmir', 'Ladakh', 'Lakshadweep', 'Puducherry',
];

/** [value the API expects, label]. */
export const REPORT_REASONS = [
  ['spam', 'Spam'], ['harassment', 'Harassment'], ['fake_profile', 'Fake profile'], ['scam', 'Asking for money or a scam'],
  ['inappropriate', 'Inappropriate content'], ['other', 'Something else'],
];
